var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4751_37664",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4751_37664)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V24H0V0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.6667V16.6667H32V14.6667H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.3333V20.3333H32V18.3333H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.33325V9.33325H32V7.33325H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22V24H32V22H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11V13H32V11H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V2H32V0H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.66675V5.66675H32V3.66675H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72197 2.93871L0.996087 3.44759L1.24115 2.54198L0.596436 1.96807H1.43852L1.72095 1.229L2.05212 1.96807H2.76998L2.20594 2.54198L2.4243 3.44759L1.72197 2.93871ZM5.72197 2.93871L4.99609 3.44759L5.24115 2.54198L4.59644 1.96807H5.43852L5.72095 1.229L6.05212 1.96807H6.76998L6.20594 2.54198L6.4243 3.44759L5.72197 2.93871ZM8.99609 3.44759L9.72197 2.93871L10.4243 3.44759L10.2059 2.54198L10.77 1.96807H10.0521L9.72095 1.229L9.43852 1.96807H8.59644L9.24115 2.54198L8.99609 3.44759ZM13.722 2.93871L12.9961 3.44759L13.2412 2.54198L12.5964 1.96807H13.4385L13.721 1.229L14.0521 1.96807H14.77L14.2059 2.54198L14.4243 3.44759L13.722 2.93871ZM0.996087 7.44759L1.72197 6.93871L2.4243 7.44759L2.20594 6.54198L2.76998 5.96807H2.05212L1.72095 5.229L1.43852 5.96807H0.596436L1.24115 6.54198L0.996087 7.44759ZM5.72197 6.93871L4.99609 7.44759L5.24115 6.54198L4.59644 5.96807H5.43852L5.72095 5.229L6.05212 5.96807H6.76998L6.20594 6.54198L6.4243 7.44759L5.72197 6.93871ZM8.99609 7.44759L9.72197 6.93871L10.4243 7.44759L10.2059 6.54198L10.77 5.96807H10.0521L9.72095 5.229L9.43852 5.96807H8.59644L9.24115 6.54198L8.99609 7.44759ZM13.722 6.93871L12.9961 7.44759L13.2412 6.54198L12.5964 5.96807H13.4385L13.721 5.229L14.0521 5.96807H14.77L14.2059 6.54198L14.4243 7.44759L13.722 6.93871ZM0.996087 11.4476L1.72197 10.9387L2.4243 11.4476L2.20594 10.542L2.76998 9.96807H2.05212L1.72095 9.229L1.43852 9.96807H0.596436L1.24115 10.542L0.996087 11.4476ZM5.72197 10.9387L4.99609 11.4476L5.24115 10.542L4.59644 9.96807H5.43852L5.72095 9.229L6.05212 9.96807H6.76998L6.20594 10.542L6.4243 11.4476L5.72197 10.9387ZM8.99609 11.4476L9.72197 10.9387L10.4243 11.4476L10.2059 10.542L10.77 9.96807H10.0521L9.72095 9.229L9.43852 9.96807H8.59644L9.24115 10.542L8.99609 11.4476ZM13.722 10.9387L12.9961 11.4476L13.2412 10.542L12.5964 9.96807H13.4385L13.721 9.229L14.0521 9.96807H14.77L14.2059 10.542L14.4243 11.4476L13.722 10.9387ZM16.9961 3.44759L17.722 2.93871L18.4243 3.44759L18.2059 2.54198L18.77 1.96807H18.0521L17.721 1.229L17.4385 1.96807H16.5964L17.2412 2.54198L16.9961 3.44759ZM17.722 6.93871L16.9961 7.44759L17.2412 6.54198L16.5964 5.96807H17.4385L17.721 5.229L18.0521 5.96807H18.77L18.2059 6.54198L18.4243 7.44759L17.722 6.93871ZM16.9961 11.4476L17.722 10.9387L18.4243 11.4476L18.2059 10.542L18.77 9.96807H18.0521L17.721 9.229L17.4385 9.96807H16.5964L17.2412 10.542L16.9961 11.4476ZM3.72197 4.93871L2.99609 5.44759L3.24115 4.54198L2.59644 3.96807H3.43852L3.72095 3.229L4.05212 3.96807H4.76998L4.20594 4.54198L4.4243 5.44759L3.72197 4.93871ZM6.99609 5.44759L7.72197 4.93871L8.4243 5.44759L8.20594 4.54198L8.76998 3.96807H8.05212L7.72095 3.229L7.43852 3.96807H6.59644L7.24115 4.54198L6.99609 5.44759ZM11.722 4.93871L10.9961 5.44759L11.2412 4.54198L10.5964 3.96807H11.4385L11.721 3.229L12.0521 3.96807H12.77L12.2059 4.54198L12.4243 5.44759L11.722 4.93871ZM2.99609 9.44759L3.72197 8.93871L4.4243 9.44759L4.20594 8.54198L4.76998 7.96807H4.05212L3.72095 7.229L3.43852 7.96807H2.59644L3.24115 8.54198L2.99609 9.44759ZM7.72197 8.93871L6.99609 9.44759L7.24115 8.54198L6.59644 7.96807H7.43852L7.72095 7.229L8.05212 7.96807H8.76998L8.20594 8.54198L8.4243 9.44759L7.72197 8.93871ZM10.9961 9.44759L11.722 8.93871L12.4243 9.44759L12.2059 8.54198L12.77 7.96807H12.0521L11.721 7.229L11.4385 7.96807H10.5964L11.2412 8.54198L10.9961 9.44759ZM15.722 4.93871L14.9961 5.44759L15.2412 4.54198L14.5964 3.96807H15.4385L15.721 3.229L16.0521 3.96807H16.77L16.2059 4.54198L16.4243 5.44759L15.722 4.93871ZM14.9961 9.44759L15.722 8.93871L16.4243 9.44759L16.2059 8.54198L16.77 7.96807H16.0521L15.721 7.229L15.4385 7.96807H14.5964L15.2412 8.54198L14.9961 9.44759Z",
    fill: "#F7FCFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.0d6639041fc11d43c8433e9dc6f3a8ba.svg";
export { ForwardRef as ReactComponent };